angular.module('logbook')
.config(['$qProvider', function ($qProvider) {
   $qProvider.errorOnUnhandledRejections(true);
}]);